/**
 * Сколько записей голоса идёт прямо сейчас — для предупреждения при уходе.
 *
 * ⚠️ ЗАЧЕМ ОТДЕЛЬНО ОТ БЛОКА. Заданий «запись» в разделе бывает несколько, а
 * перехват ухода со страницы в роутере — один на страницу (`useBlocker`
 * разрешает только один). Блоки отмечаются здесь, страница урока смотрит сюда.
 * Проверки — `openAnswerBlocks.test.ts`.
 */

let active = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

/** Запись началась. Возвращает отметку «закончилась»; повторный вызов безвреден. */
export function recordingStarted(): () => void {
  active += 1;
  emit();
  let done = false;
  return () => {
    if (done) return;
    done = true;
    active -= 1;
    emit();
  };
}

export function activeRecordings(): number {
  return active;
}

/**
 * Сколько идёт отправок, которые уход со страницы ТЕРЯЕТ.
 *
 * ⚠️ ПОЧЕМУ НЕ ВСЯКАЯ ОТПРАВКА. В уроке запись ложится в очередь
 * (`lib/outbox.ts`) ещё до начала загрузки и переживает и уход, и закрытие
 * вкладки — предупреждать там не о чем, а ложная тревога учит жать «уйти» не
 * глядя. А в домашке загрузка идёт прямой мутацией, мимо очереди: ушёл — и
 * записи нет. Считаем только такие.
 */
let unsafeSends = 0;

/** Началась отправка, которую уход теряет. Возвращает отметку «закончилась». */
export function unsafeSendStarted(): () => void {
  unsafeSends += 1;
  emit();
  let done = false;
  return () => {
    if (done) return;
    done = true;
    unsafeSends -= 1;
    emit();
  };
}

export function activeUnsafeSends(): number {
  return unsafeSends;
}

export function subscribeRecordings(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
